import { snakeCase } from "lodash";
import VueI18n from "vue-i18n";

import { VueComponent } from "../../../../../types/VueComponent";
import { PeriodConditionsTypeEnum } from "../types";
import { BasePeriodCondition } from "./BasePeriodCondition";

export abstract class BasePeriodConditionBuilder {
  abstract type: PeriodConditionsTypeEnum

  abstract view: Partial<{
    setting: VueComponent
    preview: VueComponent
  }>

  abstract getModel(): BasePeriodCondition

  prepareModel(condition?: BasePeriodCondition) {
    return this.getModel()
  }

  get titleKey() {
    return `period_conditions_${ snakeCase(this.type.toLowerCase()) }_title`
  }
}
